export default "__VITE_ASSET__Q1P_JoOU__"